import { Progress } from 'radix-ui';
import React from 'react';

import { cn } from '~/utils/styles';

interface LoadingBarProps {
  className?: string;
  isLoading?: boolean;
}

const LoadingBar: React.FC<LoadingBarProps> = ({ className, isLoading = true }) => {
  return (
    <Progress.Root
      className={cn(
        'relative h-1 w-full overflow-hidden bg-primary-dark/20 shadow-md transition-opacity',
        className,
      )}
      style={{ opacity: isLoading ? 1 : 0 }}
    >
      <Progress.Indicator
        className={cn(
          'h-full w-full bg-white/80 backdrop-blur-xs',
          isLoading ? 'animate-loading-bar' : '',
        )}
      />
    </Progress.Root>
  );
};

export default LoadingBar;
